function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  fill: "none",
  stroke: "#D2DA4E",
  strokeWidth: 5.5,
  strokeMiterlimit: 10,
  cx: 82.75,
  cy: 82.75,
  r: 80
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#D2DA4E",
  d: "M64.204,114.25c-0.171,0-0.342-0.011-0.514-0.032c-1.23-0.159-2.317-0.88-2.942-1.951L42.842,81.567 c-1.113-1.908-0.47-4.357,1.439-5.47c1.909-1.115,4.358-0.469,5.47,1.439l15.293,26.217l51.332-51.332 c1.562-1.563,4.095-1.563,5.656,0c1.563,1.561,1.563,4.095,0,5.656l-55,55C66.277,113.834,65.259,114.25,64.204,114.25"
});

var SvgFatto = function SvgFatto(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 167,
    height: 166,
    viewBox: "-0.948 -0.075 167 166",
    enableBackground: "new -0.948 -0.075 167 166",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFatto, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fatto.198a07c3.svg";
export { ForwardRef as ReactComponent };